import { Button, Grid2, Snackbar, TextField, Typography } from "@mui/material";
import TokenError from "../tokenError";
import { useEffect, useRef, useState } from "react";
import { Label } from "flowbite-react";
import defaultImgg from "../../assets/images/defaultImgg.svg";
import uploadIcon from '../../assets/images/uploadIcon.svg';
import { useNavigate } from "react-router-dom";
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import axios from "axios";

const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
};

const GeneralSettings = () =>{
    const navigate = useNavigate();
    const [tokenExpired, setTokenExpired] = useState(false);
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [uploadedImage, setUploadedImage] = useState(defaultImgg); // Manage image state
    const [uploadedFavicon, setUploadedFavicon] = useState(defaultImgg);
    const [clientName, setClientName] = useState('');
    const [supportEmail, setSupportEmail] = useState('');
    const [supportEmailError, setSupportEmailError] = useState('');
    const fileInputRef = useRef(null);
    const faviconInputRef = useRef(null);

    const [keysData, setKeysData] = useState([]);
    const originalKeysRef = useRef({}); // mapping_id -> original mapped_value

    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const corporateIdFromLocal = localStorage.getItem('corporateId');
    const [perUserRideLimit, setPerUserRideLimit] = useState('');
    const [perUserSpendLimit, setPerUserSpendLimit] = useState('');

    const handleUploadClick = () => {
        // Trigger file input on click
        fileInputRef.current.click();
    };

    const handleUploadFavicon = () => {
        faviconInputRef.current.click();
    }

    const handleFileChange = (type) => async(event) => {
        const file = event.target.files[0];
        if (file) {
            const formData = new FormData();
            formData.append('image', file);
    
            try {
                const response = await axios.post(operationsUrl + '/upload_image', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
    
                const s3Url = response.data.url;
                const newImage = {
                    name: file.name,
                    src: s3Url,
                    isUploaded: true,
                };
    
                if(type=='brand') setUploadedImage(s3Url);
                if(type=='favicon') setUploadedFavicon(s3Url);
            } catch (error) {
                console.error('Error uploading image:', error);
            }
        }
    };

    const fetchGeneralSettings = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/settings/fetch_client_info';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                // setDataa(response.data);
                const fetchedData = response.data[0];
                setClientName(fetchedData.client_name);
                setSupportEmail(fetchedData.support_email);
                if(fetchedData.brand_logo) setUploadedImage(fetchedData.brand_logo);
                if(fetchedData.favicon) setUploadedFavicon(fetchedData.favicon);
                setKeysData(response.clientKeys);
                // snapshot original values for comparison on update
                const originalMap = {};
                (response.clientKeys || []).forEach((k) => {
                    if (k && k.mapping_id) {
                        originalMap[k.mapping_id] = k.mapped_value ?? '';
                    }
                });
                originalKeysRef.current = originalMap;

                setPerUserRideLimit(response.corporateDetails?.[0]?.per_user_ride_limit);
                setPerUserSpendLimit(response.corporateDetails?.[0]?.per_user_spend_limit);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=> {
        fetchGeneralSettings();
    },[])

    const saveData = async() =>{
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            client_name: clientName,
            support_email: supportEmail,
            // brand_logo: uploadedImage,
            // favicon: uploadedFavicon
        };
        if(uploadedImage!=defaultImgg) payload['brand_logo']=uploadedImage;
        if(uploadedFavicon!=defaultImgg) payload['favicon']=uploadedFavicon;

        try {
            const url = operationsUrl + '/settings/update_client_info/admin';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                if (uploadedFavicon) {
                    const link = document.querySelector("#dynamic-favicon");
                    if (link) {
                        link.href = uploadedFavicon;
                    }
                }
                // Update logo immediately if changed
                if (uploadedImage && uploadedImage !== defaultImgg) {
                    // Update localStorage for brand logo
                    localStorage.setItem('client_brand_logo', uploadedImage);
                    
                    // Dispatch custom event to notify Navbar about logo change
                    window.dispatchEvent(new Event('storage_updated'));
                }
            }
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
            else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }
    }

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    const handleKeyChange = (keyId, value) => {
        setKeysData((prev) =>
            prev.map((k) => (k.key_id === keyId ? { ...k, mapped_value: value } : k))
        );
    };
    const validateKeyValue = (item) => {
        if (item.input_type !== 'number') {
            return null;
        }

        const value = item.mapped_value;

        // Empty value
        if (value === '' || value == null) {
            return `${item.label} is required`;
        }

        const numericValue = Number(value);

        if (Number.isNaN(numericValue)) {
            return `${item.label} must be a valid number`;
        }

        if (
            item.allowed_min != null &&
            numericValue < Number(item.allowed_min)
        ) {
            return `${item.label} must be at least ${item.allowed_min}`;
        }

        if (
            item.allowed_max != null &&
            numericValue > Number(item.allowed_max)
        ) {
            return `${item.label} must be at most ${item.allowed_max}`;
        }

        return null;
    };


    const saveKeysData = async () => {
        const invalidKey = (keysData || [])
            .map((item) => ({
                item,
                error: validateKeyValue(item),
            }))
            .find(({ error }) => error);

        if (invalidKey) {
            setMessage(invalidKey.error);
            showSnackbar(true);
            return;
        }
        const addSchema = (keysData || [])
            .filter((k) => !k?.mapping_id && (k?.mapped_value ?? '') !== '')
            .map((k) => ({ key_id: k.key_id, value: k.mapped_value }));

        const updateSchema = (keysData || [])
            .filter((k) => !!k?.mapping_id)
            // include only if value changed compared to original snapshot
            .filter((k) => {
                const prev = originalKeysRef.current[k.mapping_id] ?? '';
                const curr = k?.mapped_value ?? '';
                return String(curr) !== String(prev);
            })
            // optionally skip empty values if API shouldn't receive them
            .filter((k) => (k?.mapped_value ?? '') !== '')
            .map((k) => ({ id: k.mapping_id, value: k.mapped_value }));

        const payload = {
            token: localStorage.getItem('token'),
        };
        if(addSchema.length>0){
            payload.add = addSchema;
        }
        if(updateSchema.length>0){
            payload.update = updateSchema;
        }
        if(addSchema.length==0 && updateSchema.length==0){
            setMessage('Nothing to update.');
            showSnackbar(true);
            return;
        }
        try {
            const url = operationsUrl + '/settings/add_update_client_keys';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                // refresh original snapshot to current values after successful save
                const updatedMap = { ...originalKeysRef.current };
                (keysData || []).forEach((k) => {
                    if (k && k.mapping_id) {
                        updatedMap[k.mapping_id] = k.mapped_value ?? '';
                    }
                });
                originalKeysRef.current = updatedMap;
            }
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
            else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }
    }

    const saveCorporateData = async() => {
        const token = localStorage.getItem('token');
        const payload={
            token: token,
            per_user_ride_limit: perUserRideLimit,
            per_user_spend_limit: perUserSpendLimit,
            corporate_id: corporateIdFromLocal
        }
        try {
            const url = operationsUrl + '/corporates/add_update_corporate_limits';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
            }
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
            else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }
    }

    return(
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                General Settings
            </Typography>

            <Grid2 sx={{margin:"4px", backgroundColor:"#fff", borderRadius:'8px', padding:'12px', marginTop:'12px'}}>
                <Typography sx={{color:'#4E545D', fontSize:'24px'}}> Client Settings</Typography>

                <Grid2 item container sx={{marginTop:'12px'}} spacing={4} size={12}>
                    <Grid2 item size={6}>
                        <Label>Client Name<span style={{ color: 'red' }}>*</span></Label>
                        <TextField  sx={{marginTop:'1%', color:'#1A1E25'}}
                            placeholder="Client Name" fullWidth variant="outlined" type="text" 
                            value={clientName}
                            onChange={(e) => setClientName(e.target.value)}
                            InputProps={{
                                inputProps: { min: 0 },
                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                            }}
                        />
                    </Grid2>

                    <Grid2 item size={6}>
                        <Label>Support Email<span style={{ color: 'red' }}>*</span></Label>
                        {/* <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                            placeholder="Support Email" fullWidth variant="outlined" type="text" 
                            value={supportEmail}
                            onChange={(e) => setSupportEmail(e.target.value)}
                            InputProps={{
                                inputProps: { min: 0 },
                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                            }}
                        /> */}
                        <TextField sx={{marginTop:'1%'}}
                            placeholder="Enter Email" fullWidth variant="outlined" type="text" 
                            value={supportEmail}
                            onChange={(e) => { 
                                const value = e.target.value;
                                setSupportEmail(value);
                                
                                // Clear previous error
                                if (supportEmailError) setSupportEmailError('');
                                
                                // Validate email format if not empty
                                if (value && !validateEmail(value)) {
                                    setSupportEmailError('Please enter a valid email address');
                                }
                            }}
                            error={!!supportEmailError}
                            helperText={supportEmailError}
                            InputProps={{
                                inputProps: { min: 0 },
                                style: {height: '50px', fontSize: '16px', padding: '8px 14px', backgroundColor:'#fff', borderRadius:'8px'}
                            }}
                        />
                    </Grid2>
                </Grid2>

                <Grid2 item container sx={{marginTop:'24px'}} spacing={4} size={12}>
                    <Grid2 item sx={{backgroundColor:'#F9F9F9', padding:'12px', borderRadius:'8px'}} size={6}>
                        <Typography sx={{color:'#4E545D'}}>Brand Logo</Typography>
                    </Grid2>

                    <Grid2 item sx={{backgroundColor:'#F9F9F9', padding:'12px', borderRadius:'8px'}} size={6}>
                        <Typography sx={{color:'#4E545D'}}>Favicon</Typography>
                    </Grid2>
                </Grid2>

                <Grid2 item container sx={{marginTop:'24px'}} spacing={4} size={12}>
                    <Grid2 item sx={{display:'flex'}} size={6}>
                        <Grid2 item>
                            {/* <img src={defaultImgg} alt="defaultProfile" /> */}
                            <img
                                src={uploadedImage}
                                alt="uploadedProfile"
                                style={{
                                    width: "100px",
                                    height: "100px",
                                    borderRadius: "8px",
                                    objectFit: "cover",
                                }}
                            />
                        </Grid2>
                        <Grid2 item sx={{ marginLeft:'12px', marginTop:'2%'}}>
                            <Typography sx={{fontSize:'12px', color:'#83888E', marginBottom:'8%'}}>Upload Brand Logo</Typography>
                            <Grid2 item onClick={handleUploadClick} sx={{border:'1px solid #D1D5DB', display:'flex', padding:'4px 8px', borderRadius:'8px', width:'150px', 
                            cursor:'pointer', "&:hover": { borderColor: "#0065FF"},}}>
                                <Grid2><img src={uploadIcon} alt="uploadIcon" /></Grid2>
                                <Typography sx={{fontSize:'14px', color:'#83888E', marginTop:'4%'}}>Upload</Typography>

                                <input
                                    type="file"
                                    accept="image/*"
                                    ref={fileInputRef}
                                    style={{ display: "none" }}
                                    onChange={handleFileChange('brand')}
                                />
                            </Grid2>
                        </Grid2>
                    </Grid2>

                    <Grid2 item sx={{display:'flex'}} size={6}>
                        <Grid2 item>
                            <img
                                src={uploadedFavicon}
                                alt="uploadedFavicon"
                                style={{
                                    width: "100px",
                                    height: "100px",
                                    borderRadius: "8px",
                                    objectFit: "cover",
                                }}
                            />
                        </Grid2>
                        <Grid2 item sx={{ marginLeft:'12px', marginTop:'2%'}}>
                            <Typography sx={{fontSize:'12px', color:'#83888E', marginBottom:'8%'}}>Upload Favicon</Typography>
                            <Grid2 item onClick={handleUploadFavicon} sx={{border:'1px solid #D1D5DB', display:'flex', padding:'4px 8px', borderRadius:'8px', width:'150px', 
                            cursor:'pointer', "&:hover": { borderColor: "#0065FF"},}}>
                                <Grid2><img src={uploadIcon} alt="uploadIcon" /></Grid2>
                                <Typography sx={{fontSize:'14px', color:'#83888E', marginTop:'4%'}}>Upload</Typography>

                                <input
                                    type="file"
                                    accept="image/*"
                                    ref={faviconInputRef}
                                    style={{ display: "none" }}
                                    onChange={handleFileChange('favicon')}
                                />
                            </Grid2>
                        </Grid2>
                    </Grid2>
                </Grid2>

                <Grid2 item sx={{marginTop:'24px', alignItems:'center', justifyContent:'center', display:'flex', marginBottom:'24px'}} size={12}>
                    <Button onClick={saveData} variant="contained">Update</Button>
                </Grid2>
            </Grid2>

            {corporateIdFromLocal!=0 && 
                <Grid2 sx={{margin:"4px", backgroundColor:"#fff", borderRadius:'8px', padding:'12px', marginTop:'12px'}}>
                    <Typography sx={{color:'#4E545D', fontSize:'24px'}}> Corporate Settings</Typography>

                    <Grid2 item container sx={{marginTop:'12px'}} spacing={4} size={12}>
                        <Grid2 item size={6}>
                            <Label>Per User Ride Limit<span style={{ color: 'red' }}>*</span></Label>
                            <TextField  sx={{marginTop:'2%'}}
                                placeholder="Max Ride Limit" fullWidth variant="outlined" type="number" 
                                value={perUserRideLimit}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*$/.test(value)) {
                                        setPerUserRideLimit(value);
                                    }
                                }}
                                InputProps={{
                                    inputProps: { min: 0 }, // Prevent values less than zero
                                    style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                }}
                            />
                        </Grid2>
                        <Grid2 item size={6}>
                            <Label>Per User Spend Limit<span style={{ color: 'red' }}>*</span></Label>
                            <TextField  sx={{marginTop:'2%'}}
                                placeholder="Max Spend Limit" fullWidth variant="outlined" type="number" 
                                value={perUserSpendLimit}
                                onChange={(e) => setPerUserSpendLimit(e.target.value)}
                                InputProps={{
                                    inputProps: { min: 0 }, // Prevent values less than zero
                                    style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                }}
                            />
                        </Grid2>
                    </Grid2>

                    <Grid2 item sx={{marginTop:'24px', alignItems:'center', justifyContent:'center', display:'flex', marginBottom:'24px'}} size={12}>
                        <Button onClick={saveCorporateData} variant="contained">Update</Button>
                    </Grid2>
                </Grid2>
            }

            {keysData?.length>0 &&
                <Grid2 sx={{margin:"4px", backgroundColor:"#fff", borderRadius:'8px', padding:'12px', marginTop:'12px'}}>
                    <Typography sx={{color:'#4E545D', fontSize:'24px'}}> Feature's Settings</Typography>

                    <Grid2 container sx={{marginTop:'12px'}} spacing={4}>
                        {keysData.map((item) => (
                            console.log(item,item),
                            <Grid2 item size={6} key={item.key_id}>
                            <Label>
                                {item.label || `Key ${item.key_id}`}
                                {(item.allowed_min != null || item.allowed_max != null) && (
                                    <span
                                        style={{
                                            marginLeft: '8px',
                                            fontSize: '12px',
                                            color: '#83888E',
                                            fontWeight: '400',
                                        }}
                                    >
                                        {item.allowed_min != null && item.allowed_max != null
                                            ? `(Allowed Range: ${item.allowed_min} – ${item.allowed_max})`
                                            : item.allowed_min != null
                                                ? `(Minimum : ${item.allowed_min})`
                                                : `(Maximum : ${item.allowed_max})`}
                                    </span>
                                )}
                            </Label>
                                <TextField
                                    sx={{ marginTop: '1%' }}
                                    placeholder={''}
                                    type={item.input_type || 'text'}
                                    fullWidth
                                    variant="outlined"
                                    value={item.mapped_value ?? ''}
                                    onChange={(e) => handleKeyChange(item.key_id, e.target.value)}
                                    inputProps={{
                                        min: item.allowed_min ?? undefined,
                                        max: item.allowed_max ?? undefined,
                                        step: 1,
                                    }}
                                    InputProps={{
                                        style: { height: '50px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#FFFFFF', borderRadius: '8px' }
                                    }}
                                />
                                <Grid2 item xs={12}>
                                    <Typography sx={{fontSize:'12px', color:'gray'}}>{item.key_description}</Typography>
                                </Grid2>
                            </Grid2>
                        ))}
                        
                    </Grid2>
                    <Grid2 item sx={{marginTop:'24px', alignItems:'center', justifyContent:'center', display:'flex', marginBottom:'24px'}} size={12}>
                        <Button onClick={saveKeysData} variant="contained">Update</Button>
                    </Grid2>
                </Grid2>
            }

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>

        </div>

    )
}
export default GeneralSettings;